/* AppsWithTextHighlights.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives/responsive';
import { AppTile } from '@atlassian/mpac-app-tile';
import { BodyNormal, breakpointValues, FluidContainer, H3, LinkWithIcon, Skeleton, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _59 = "._4t3i1f23{height:25rem}";
const _58 = "._1ul9d60k{min-width:18.75rem}";
const _57 = "._bfhkvuon{background-color:var(--ds-surface,#fff)}";
const _56 = "._2rkogktf{border-radius:20px}";
const _55 = "@media not all and (min-width:64rem){._1ph49sye{grid-template-columns:repeat(2,minmax(0,1fr))}._sp8t1ejb{padding-left:var(--ds-space-300,24px)}._axwi1ejb{padding-right:var(--ds-space-300,24px)}}";
const _54 = "@media not all and (min-width:48rem){._1rkb1osq{max-width:100%}._suga1txw{display:flex}._1o831wug{overflow-x:auto}._1jk9glyw{scrollbar-width:none}._3nz5glyw{ms-overflow-style:none}._z61jglyw::-webkit-scrollbar{display:none}._q71vidpf>a{flex-shrink:0}._1o44d60k>a{max-width:18.75rem}._1hir1wug>a{height:auto}}";
const _53 = "._1reoewfl{overflow-x:visible}";
const _52 = "._1bahv2br{justify-content:start}";
const _51 = "._19bvxy5q{padding-left:var(--ds-space-400,2pc)}";
const _50 = "._u5f3xy5q{padding-right:var(--ds-space-400,2pc)}";
const _49 = "._1tke1f23{min-height:25rem}";
const _48 = "._4t3i1wug{height:auto}";
const _47 = "._yv0ewann{grid-template-columns:repeat(2,18.75rem)}";
const _46 = "._1e0c11p5{display:grid}";
const _45 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const _44 = "._5is515f2 *{color:var(--_w4n06k)}";
const _43 = "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}";
const _42 = "._4t3i163v{height:10rem}";
const _41 = "._1bsb163v{width:10rem}";
const _40 = "._19pk1ekg{margin-top:-2.5rem}";
const _39 = "@media not all and (min-width:64rem){._3wvkm14n{margin-top:-2.2rem}}";
const _38 = "._syaz15cr{color:var(--ds-text-inverse,#fff)}";
const _37 = "._19pkidpf{margin-top:0}";
const _36 = "@media not all and (min-width:64rem){._1mjb1ule{display:block}}";
const _35 = "._4t3i1pv1{height:140%}";
const _34 = "._154iidpf{top:0}";
const _33 = "._1e0cglyw{display:none}";
const _32 = "@media not all and (min-width:64rem){._blhdn7od{min-width:unset}._8fz61osq{max-width:100%}._sp8toahv{padding-left:var(--ds-space-600,3pc)}._axwioahv{padding-right:var(--ds-space-600,3pc)}}";
const _31 = "@media not all and (min-width:48rem){._1mae1ejb{padding-left:var(--ds-space-300,24px)}._1ggm1ejb{padding-right:var(--ds-space-300,24px)}}";
const _30 = "._u5f3xncg{padding-right:var(--ds-space-800,4pc)}";
const _29 = "._19bvxncg{padding-left:var(--ds-space-800,4pc)}";
const _28 = "._1ul91f23{min-width:25rem}";
const _27 = "._1bah1yb4{justify-content:space-between}";
const _26 = "._2lx21bp4{flex-direction:column}";
const _25 = "._19bvidpf{padding-left:0}";
const _24 = "._n3tdidpf{padding-bottom:0}";
const _23 = "._u5f3idpf{padding-right:0}";
const _22 = "._ca0qidpf{padding-top:0}";
const _21 = "._i0dlf1ug{flex-basis:0%}";
const _20 = "._1o9zkb7n{flex-shrink:1}";
const _19 = "._16jlkb7n{flex-grow:1}";
const _18 = "@media not all and (min-width:64rem){._1mjbglyw{display:none}}";
const _17 = "._c71l3jzc{max-height:28.125rem}";
const _16 = "._4t3i1osq{height:100%}";
const _15 = "._1bsb1osq{width:100%}";
const _14 = "._1ltvidpf{left:0}";
const _13 = "._154i66rk{top:45px}";
const _12 = "._kqswstnw{position:absolute}";
const _11 = "._1pby1mrw{z-index:-1}";
const _10 = "._1e0c1ule{display:block}";
const _9 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}._3wvk1epz{margin-top:var(--ds-space-1000,5pc)}}";
const _8 = "._19pkoahv{margin-top:var(--ds-space-600,3pc)}";
const _7 = "._1p57xy5q{row-gap:var(--ds-space-400,2pc)}";
const _6 = "._1n261g80{flex-wrap:wrap}";
const _5 = "._2lx2vrvc{flex-direction:row}";
const _4 = "._4cvr1fhb{align-items:stretch}";
const _3 = "._kqswh2mm{position:relative}";
const _2 = "._1e0c1txw{display:flex}";
const container = null;
const descriptionContainer = null;
const descriptionContent = null;
const appGridStyles = null;
const skeletonContainer = null;
const exploreLinkContainer = null;
const bgVectorMobileAndTablet = null;
const bgVectorDesktop = null;
const iconStyles = null;
const skeletonStyles = null;
export const AppsWithTextHighlights = _ref => {
  let {
    icon,
    apps,
    loading,
    environment,
    source,
    content,
    maxAppsToShow = 2,
    hideTagline = false,
    clipPath,
    backgroundColor,
    textColor,
    onLinkClick
  } = _ref;
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const Container = isMobile ? React.Fragment : FluidContainer;
  // Dynamic link container to force link colors
  const dynamicLinkContainer = null;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_2, _3, _4, _5, _6, _7, _8, _9]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_1e0c1txw _kqswh2mm _4cvr1fhb _2lx2vrvc _1n261g80 _1p57xy5q _19pkoahv _na0i1bp4 _3wvk1epz"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_10, _11, _12, _13, _14, _15, _16, _17, _18]
          }), /*#__PURE__*/_jsx("div", {
            style: {
              WebkitClipPath: clipPath === null || clipPath === void 0 ? void 0 : clipPath.desktop,
              background: backgroundColor
            },
            className: ax(["_1e0c1ule _1pby1mrw _kqswstnw _154i66rk _1ltvidpf _1bsb1osq _4t3i1osq _c71l3jzc _1mjbglyw"])
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_19, _20, _21, _22, _23, _24, _25, _3, _2, _26, _27, _28, _29, _30, _31, _32]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _1e0c1txw _2lx21bp4 _1bah1yb4 _1ul91f23 _19bvxncg _u5f3xncg _1mae1ejb _1ggm1ejb _blhdn7od _8fz61osq _sp8toahv _axwioahv"]),
            children: [/*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_14, _15, _33, _11, _12, _34, _35, _36]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  WebkitClipPath: isMobile ? clipPath === null || clipPath === void 0 ? void 0 : clipPath.mobile : clipPath === null || clipPath === void 0 ? void 0 : clipPath.desktop,
                  background: backgroundColor
                },
                className: ax(["_1ltvidpf _1bsb1osq _1e0cglyw _1pby1mrw _kqswstnw _154iidpf _4t3i1pv1 _1mjb1ule"])
              })]
            }), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_37, _38, _39]
              }), /*#__PURE__*/_jsxs("div", {
                className: ax(["_19pkidpf _syaz15cr _3wvkm14n"]),
                children: [/*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_40, _41, _42]
                  }), /*#__PURE__*/_jsx("img", {
                    src: icon,
                    alt: content.title,
                    className: ax(["_19pk1ekg _1bsb163v _4t3i163v"])
                  })]
                }), /*#__PURE__*/_jsx(H3, {
                  style: {
                    color: textColor
                  },
                  children: content.title
                }), /*#__PURE__*/_jsx(BodyNormal, {
                  style: {
                    color: textColor
                  },
                  children: content.description
                }), /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_43, _44]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_19pkxy5q", "_5is515f2"]),
                    style: {
                      "--_w4n06k": ix("".concat(textColor))
                    },
                    children: /*#__PURE__*/_jsx(LinkWithIcon, {
                      size: "medium",
                      type: "internal",
                      href: content.linkHref,
                      animateIcon: true,
                      underlineText: false,
                      "aria-label": content.linkAriaLabel,
                      onClick: onLinkClick,
                      children: content.linkText
                    })
                  })]
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_zulp1ejb _1e0c11p5 _yv0ewann _4t3i1wug _1tke1f23 _u5f3xy5q _19bvxy5q _1bahv2br _1reoewfl _1rkb1osq _suga1txw _1o831wug _1jk9glyw _3nz5glyw _z61jglyw _q71vidpf _1o44d60k _1hir1wug _1ph49sye _sp8t1ejb _axwi1ejb"]),
            children: loading ? Array.from({
              length: maxAppsToShow
            }).map((_, index) => /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_56, _57, _58, _59]
              }), /*#__PURE__*/_jsx("div", {
                className: ax(["_2rkogktf _bfhkvuon _1ul9d60k _4t3i1f23"]),
                children: /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_56, _15, _16, _49]
                  }), /*#__PURE__*/_jsx(Skeleton, {
                    className: ax(["_2rkogktf _1bsb1osq _4t3i1osq _1tke1f23"])
                  })]
                })
              }, "skeleton-".concat(index))]
            }, "skeleton-".concat(index))) : apps === null || apps === void 0 ? void 0 : apps.map((app, index) => /*#__PURE__*/_jsx(AppTile, {
              tileData: app,
              environment: environment,
              source: source,
              hideTagline: hideTagline,
              a11yElementType: "h4"
            }, index))
          })]
        })]
      })]
    })
  });
};